<!-- <div class="container-fluid d-flex align-items-center justify-content-center mainContainer">
    <div class="row w-100"> -->
      <!-- Left Section -->
      <!-- <div class="col-md-8 d-none d-md-flex align-items-center justify-content-center">
        <img src="assets/loginLeft.png" alt="" class="col-12 loginbgImg">
        <img src="assets/logo_icon.png" alt="" class="logoImg">
      </div> -->
      
      <!-- Right Section -->
      <!-- <div class="col-md-4 col-12 d-flex align-items-center justify-content-center rightSection">
        <div class="login-form w-60">
          <h2 class="fw-bold text-xl">New Password</h2> -->
          
          
          <!-- Updated form with proper bindings -->
          <!-- <form [formGroup]="passwordForm" class="pt-4">
            <div class="mb-4 fieldContainer">
              <div class="input-group">
                <input 
                [type]="showPassword ? 'text' : 'password'"
                  formControlName="newPassword"
                  class="form-control border-0 py-2" 
                  placeholder="Enter New Password"
                >
                <span class="input-group-text fieldIcons border-0 cursor-pointer" (click)="togglePasswordVisibility()">
                  <i class="bi" [ngClass]="showPassword ? 'bi-eye-slash' : 'bi-eye'"></i>
                </span>
              </div>
             
            </div>
            <div *ngIf="passwordForm.get('newPassword')?.invalid && passwordForm.get('newPassword')?.touched" 
            class="text-danger text-center small mb-3">
         Password must be at least 8 characters and include uppercase, lowercase, 
         number, and special character.
       </div>
            <div *ngIf="showError" class="text-danger text-center mb-3">
              {{ errorMessage }}
            </div>
            
            <div *ngIf="showSuccess" class="text-success text-center mb-3">
              {{ successMessage }}
            </div>
          
            <button 
              type="submit" 
              class="btn btn-primary w-100 py-2"
              [disabled]="passwordForm.invalid"
              (click)="updatePassword()" 
            >
              Update Password
            </button>
          </form>
      
          
        </div>
      </div>
    </div> -->
    <!-- <app-notification-popup [isOpen]="showPopup" [message]="popupMessage" [type]="popupType" (onClose)="closePopup()"></app-notification-popup> -->
  <!-- </div> -->
   
  <div class="maindiv flex items-center justify-center min-h-screen bg-cover bg-center" style="background-image: url('assets/newui/background.png');">
    <div class="bg-white formcontainer shadow-lg p-4 sm:p-8 md:p-12 w-full max-w-md mx-4">
      <h2 class="text-xl sm:text-2xl font-semibold text-center mb-2">New Password</h2>
      <p class="text-center text-gray-600 text-xs sm:text-sm mb-4">Please enter your new password</p>
    
      <form [formGroup]="passwordForm" class="pt-2 sm:pt-4">
        <div class="mb-4 fieldContainer">
          <div class="input-group flex items-center relative">
            <input 
              [type]="showPassword ? 'text' : 'password'"
              formControlName="newPassword"
              class="w-full px-3 py-2 sm:px-4 sm:py-3 border-0 rounded-lg bg-gray-100 text-gray-500 pr-10" 
              placeholder="Enter New Password"
            >
            <span class="input-group-text fieldIcons border-0 cursor-pointer absolute right-2" (click)="togglePasswordVisibility()">
              <i class="bi" [ngClass]="showPassword ? 'bi-eye-slash' : 'bi-eye'"></i>
            </span>
          </div>
        </div>
        
        <div *ngIf="passwordForm.get('newPassword')?.invalid && passwordForm.get('newPassword')?.touched" 
          class="text-danger text-center text-xs sm:text-sm mb-3">
          Password must be at least 8 characters and include uppercase, lowercase, 
          number, and special character.
        </div>
        
        <div *ngIf="showError" class="text-danger text-center text-xs sm:text-sm mb-3">
          {{ errorMessage }}
        </div>
        
        <div *ngIf="showSuccess" class="text-success text-center text-xs sm:text-sm mb-3">
          {{ successMessage }}
        </div>
      
        <button 
          type="submit" 
          class="btn btn-primary w-full py-2 sm:py-3 text-sm sm:text-base"
          [disabled]="passwordForm.invalid"
          (click)="updatePassword()" 
        >
          Update Password
        </button>
      </form>
    </div>
  </div>